// extracted by mini-css-extract-plugin
export default {"updateNotification":"styles_updateNotification__rR8LC","closeModalButtonContainer":"styles_closeModalButtonContainer__F0T+t","closeModalButton":"styles_closeModalButton__sXrqs"};